import TeamInviteWizard from './TeamInviteWizard';

export default TeamInviteWizard;
